import { render, staticRenderFns } from "./AdminReservations.vue?vue&type=template&id=6f1e0c5e&scoped=true&"
import script from "./AdminReservations.vue?vue&type=script&lang=js&"
export * from "./AdminReservations.vue?vue&type=script&lang=js&"
import style0 from "./AdminReservations.vue?vue&type=style&index=0&id=6f1e0c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e0c5e",
  null
  
)

export default component.exports